import PageHeader from "@/components/admin/header/PageHeader";
import { UploadHistoryTable } from "@/components/admin/vocUpload/UploadHistoryTable";

const VoCUploadHistoryPage: React.FC = () => {
  return (
    <>
      <PageHeader hasBack={false} title="VoCアップロード履歴" />

      <UploadHistoryTable />
    </>
  );
};

export default VoCUploadHistoryPage;
